export const chatBotMessageUsRefIdsMapping = {
  GENPOOL_CONTACT_US: 'GENPOOL|contactUsPage',
  GENERIC: 'GENPOOL',
  FINAL_INTENT: 'finalIntent',
  GENPOOL_ARTICLE_PAGE: 'GENPOOL|articlePage',
  GENPOOL_HOME_PAGE: 'GENPOOL|homePage',
};

export const experience = {
  PERSONAL: 'personal',
  BUSINESS: 'business',
  TECHNICAL: 'technical',
};

export const deviceTypes = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};

export const asyncParamDeviceType = {
  [deviceTypes.MOBILE]: 'mweb',
  [deviceTypes.TABLET]: 'tweb',
  [deviceTypes.DESKTOP]: 'desktop',
};

export const asyncOrigins = {
  CHAT_PILL: 'chatPill',
  CALL_US_TRAY: 'callUsOptionsTray',
  FINAL_CONTACT_OPTIONS: 'finalContactOptionsTray',
  DEFAULT_CONTACT_OPTIONS: 'defaultContactOptionsTray',
  COVID_BCP_CALLUS_ALERT: 'covidBcpCallUsAlertTray',
};

export const asyncPageMapping = {
  home: 'homePage',
  article: 'articlePage',
  'contact-us': 'contactUs',
};

export const contactChannels = {
  RESOLUTION: 'resolution',
  COMMUNITY: 'community',
  MESSAGE_CENTER: 'message-center',
};

export const BNA = 'BNA';

export const channelMap = {
  email: 'EMAIL',
  message: 'MESSAGE_US',
  community: 'COMMUNITY',
  resCenter: 'RES_CENTER',
  seller: 'SELLER',
  chat: 'CHAT',
};

export const callUsChannelMapping = {
  HELP_CENTER: 'helpCenter',
  EMAIL: 'emailUs',
  COMMUNITY: 'community',
  RES_CENTER: 'resolution',
  MESSAGE_US: 'message',
};

export const pageName = {
  CONTACT_US: 'contact-us',
};

export const CC3Channel = 'CC2';

export const OMNI_CHANNEL_API_SESSION_KEY = 'OmniChannelAPITriggered';

export const tax = 'tax';

export const urlConstants = {
  FUNDS_URL: '/businessprovision/funds',
  HELP_CENTER_URL: '/smarthelp/home',
  CONTACT_US_URL: '/smarthelp/contact-us',
};

export const articleChannelTypes = {
  OMNI_CHANNEL: 'OMNI',
  BNA_CHANNEL: 'BNA',
  CC3_CHANNEL: 'CC2',
};

export const pathNames = {
  CONTACT_US: 'contactUs',
  HOME: 'home',
  MINIHELP: 'miniHelp',
};
export const topicNames = {
  PRIVACY: 'privacy',
};
